/**
 * belfastpilates-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BookRequest', 'model/BookResponse', 'model/BuildingRequest', 'model/BuildingResponse', 'model/BusinessRequest', 'model/BusinessResponse', 'model/CalendarRequest', 'model/CalendarResponse', 'model/ConfigurationRequest', 'model/ConfigurationResponse', 'model/LoginRequest', 'model/LoginResponse', 'model/MigrateRequest', 'model/MigrateResponse', 'model/NotificationRequest', 'model/NotificationResponse', 'model/PaymentRequest', 'model/PaymentResponse', 'model/RoomRequest', 'model/RoomResponse', 'model/RuleRequest', 'model/RuleResponse', 'model/ScheduleRequest', 'model/ScheduleResponse', 'model/ServiceRequest', 'model/ServiceResponse', 'model/SetRequest', 'model/SetResponse', 'model/SwapRequest', 'model/SwapResponse', 'model/UserRequest', 'model/UserResponse', 'model/VoucherRequest', 'model/VoucherResponse'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/BookRequest'), require('../model/BookResponse'), require('../model/BuildingRequest'), require('../model/BuildingResponse'), require('../model/BusinessRequest'), require('../model/BusinessResponse'), require('../model/CalendarRequest'), require('../model/CalendarResponse'), require('../model/ConfigurationRequest'), require('../model/ConfigurationResponse'), require('../model/LoginRequest'), require('../model/LoginResponse'), require('../model/MigrateRequest'), require('../model/MigrateResponse'), require('../model/NotificationRequest'), require('../model/NotificationResponse'), require('../model/PaymentRequest'), require('../model/PaymentResponse'), require('../model/RoomRequest'), require('../model/RoomResponse'), require('../model/RuleRequest'), require('../model/RuleResponse'), require('../model/ScheduleRequest'), require('../model/ScheduleResponse'), require('../model/ServiceRequest'), require('../model/ServiceResponse'), require('../model/SetRequest'), require('../model/SetResponse'), require('../model/SwapRequest'), require('../model/SwapResponse'), require('../model/UserRequest'), require('../model/UserResponse'), require('../model/VoucherRequest'), require('../model/VoucherResponse'));
  } else {
    // Browser globals (root is window)
    if (!root.BelfastpilatesDevelopmentappspotcom) {
      root.BelfastpilatesDevelopmentappspotcom = {};
    }
    root.BelfastpilatesDevelopmentappspotcom.DefaultApi = factory(root.BelfastpilatesDevelopmentappspotcom.ApiClient, root.BelfastpilatesDevelopmentappspotcom.BookRequest, root.BelfastpilatesDevelopmentappspotcom.BookResponse, root.BelfastpilatesDevelopmentappspotcom.BuildingRequest, root.BelfastpilatesDevelopmentappspotcom.BuildingResponse, root.BelfastpilatesDevelopmentappspotcom.BusinessRequest, root.BelfastpilatesDevelopmentappspotcom.BusinessResponse, root.BelfastpilatesDevelopmentappspotcom.CalendarRequest, root.BelfastpilatesDevelopmentappspotcom.CalendarResponse, root.BelfastpilatesDevelopmentappspotcom.ConfigurationRequest, root.BelfastpilatesDevelopmentappspotcom.ConfigurationResponse, root.BelfastpilatesDevelopmentappspotcom.LoginRequest, root.BelfastpilatesDevelopmentappspotcom.LoginResponse, root.BelfastpilatesDevelopmentappspotcom.MigrateRequest, root.BelfastpilatesDevelopmentappspotcom.MigrateResponse, root.BelfastpilatesDevelopmentappspotcom.NotificationRequest, root.BelfastpilatesDevelopmentappspotcom.NotificationResponse, root.BelfastpilatesDevelopmentappspotcom.PaymentRequest, root.BelfastpilatesDevelopmentappspotcom.PaymentResponse, root.BelfastpilatesDevelopmentappspotcom.RoomRequest, root.BelfastpilatesDevelopmentappspotcom.RoomResponse, root.BelfastpilatesDevelopmentappspotcom.RuleRequest, root.BelfastpilatesDevelopmentappspotcom.RuleResponse, root.BelfastpilatesDevelopmentappspotcom.ScheduleRequest, root.BelfastpilatesDevelopmentappspotcom.ScheduleResponse, root.BelfastpilatesDevelopmentappspotcom.ServiceRequest, root.BelfastpilatesDevelopmentappspotcom.ServiceResponse, root.BelfastpilatesDevelopmentappspotcom.SetRequest, root.BelfastpilatesDevelopmentappspotcom.SetResponse, root.BelfastpilatesDevelopmentappspotcom.SwapRequest, root.BelfastpilatesDevelopmentappspotcom.SwapResponse, root.BelfastpilatesDevelopmentappspotcom.UserRequest, root.BelfastpilatesDevelopmentappspotcom.UserResponse, root.BelfastpilatesDevelopmentappspotcom.VoucherRequest, root.BelfastpilatesDevelopmentappspotcom.VoucherResponse);
  }
}(this, function(ApiClient, BookRequest, BookResponse, BuildingRequest, BuildingResponse, BusinessRequest, BusinessResponse, CalendarRequest, CalendarResponse, ConfigurationRequest, ConfigurationResponse, LoginRequest, LoginResponse, MigrateRequest, MigrateResponse, NotificationRequest, NotificationResponse, PaymentRequest, PaymentResponse, RoomRequest, RoomResponse, RuleRequest, RuleResponse, ScheduleRequest, ScheduleResponse, ServiceRequest, ServiceResponse, SetRequest, SetResponse, SwapRequest, SwapResponse, UserRequest, UserResponse, VoucherRequest, VoucherResponse) {
  'use strict';

  /**
   * Default service.
   * @module api/DefaultApi
   * @version 1.0.0
   */

  /**
   * Constructs a new DefaultApi. 
   * @alias module:api/DefaultApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the bookApiV1BookCreate operation.
     * @callback module:api/DefaultApi~bookApiV1BookCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookCreateBySet operation.
     * @callback module:api/DefaultApi~bookApiV1BookCreateBySetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookCreateBySetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookCreateBySet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookCreateBySet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookCreateUpdateSet operation.
     * @callback module:api/DefaultApi~bookApiV1BookCreateUpdateSetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookCreateUpdateSetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookCreateUpdateSet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookCreateUpdateSet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookDelete operation.
     * @callback module:api/DefaultApi~bookApiV1BookDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookDeleteUpdateSet operation.
     * @callback module:api/DefaultApi~bookApiV1BookDeleteUpdateSetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookDeleteUpdateSetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookDeleteUpdateSet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookDeleteUpdateSet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookEmailClass operation.
     * @callback module:api/DefaultApi~bookApiV1BookEmailClassCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookEmailClassCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookEmailClass = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookEmailClass', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetAllByIdentifier operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetAllByIdentifierCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetAllByIdentifierCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetAllByIdentifier = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetAllByIdentifier', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetByCodeTag operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetById operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetByIdGlobalUser operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetByIdGlobalUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetByIdGlobalUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetByIdGlobalUser = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetByIdGlobalUser', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetBySetId operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetBySetIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetBySetIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetBySetId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetBySetId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetBySetIdAndIdentifier operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetBySetIdAndIdentifierCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetBySetIdAndIdentifierCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetBySetIdAndIdentifier = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetBySetIdAndIdentifier', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetBySwap operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetBySwapCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetBySwapCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetBySwap = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetBySwap', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetBySwapAndServiceId operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetBySwapAndServiceIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetBySwapAndServiceIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetBySwapAndServiceId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetBySwapAndServiceId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetBySwapIdAndLevel operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetBySwapIdAndLevelCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetBySwapIdAndLevelCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetBySwapIdAndLevel = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetBySwapIdAndLevel', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetByTodaysDate operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetByTodaysDateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetByTodaysDateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetByTodaysDate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetByTodaysDate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetByUserIdAndDate operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetByUserIdAndDateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetByUserIdAndDateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetByUserIdAndDate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetByUserIdAndDate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetByUserIdAndSetId operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetByUserIdAndSetIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetByUserIdAndSetIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetByUserIdAndSetId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetByUserIdAndSetId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookGetNextBookingForSets operation.
     * @callback module:api/DefaultApi~bookApiV1BookGetNextBookingForSetsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookGetNextBookingForSetsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookGetNextBookingForSets = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookGetNextBookingForSets', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookListForUser operation.
     * @callback module:api/DefaultApi~bookApiV1BookListForUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookListForUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookListForUser = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookListForUser', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookUpdate operation.
     * @callback module:api/DefaultApi~bookApiV1BookUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookUpdateBySet operation.
     * @callback module:api/DefaultApi~bookApiV1BookUpdateBySetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookUpdateBySetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookUpdateBySet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookUpdateBySet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the bookApiV1BookUpdateBySetForClientUser operation.
     * @callback module:api/DefaultApi~bookApiV1BookUpdateBySetForClientUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BookResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BookRequest} opts.body 
     * @param {module:api/DefaultApi~bookApiV1BookUpdateBySetForClientUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BookResponse}
     */
    this.bookApiV1BookUpdateBySetForClientUser = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BookResponse;

      return this.apiClient.callApi(
        '/bookApi/v1/bookUpdateBySetForClientUser', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the buildingApiV1BuildingCreate operation.
     * @callback module:api/DefaultApi~buildingApiV1BuildingCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BuildingResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BuildingRequest} opts.body 
     * @param {module:api/DefaultApi~buildingApiV1BuildingCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BuildingResponse}
     */
    this.buildingApiV1BuildingCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BuildingResponse;

      return this.apiClient.callApi(
        '/buildingApi/v1/buildingCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the buildingApiV1BuildingDelete operation.
     * @callback module:api/DefaultApi~buildingApiV1BuildingDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BuildingResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BuildingRequest} opts.body 
     * @param {module:api/DefaultApi~buildingApiV1BuildingDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BuildingResponse}
     */
    this.buildingApiV1BuildingDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BuildingResponse;

      return this.apiClient.callApi(
        '/buildingApi/v1/buildingDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the buildingApiV1BuildingGetByCodeTag operation.
     * @callback module:api/DefaultApi~buildingApiV1BuildingGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BuildingResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BuildingRequest} opts.body 
     * @param {module:api/DefaultApi~buildingApiV1BuildingGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BuildingResponse}
     */
    this.buildingApiV1BuildingGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BuildingResponse;

      return this.apiClient.callApi(
        '/buildingApi/v1/buildingGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the buildingApiV1BuildingGetById operation.
     * @callback module:api/DefaultApi~buildingApiV1BuildingGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BuildingResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BuildingRequest} opts.body 
     * @param {module:api/DefaultApi~buildingApiV1BuildingGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BuildingResponse}
     */
    this.buildingApiV1BuildingGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BuildingResponse;

      return this.apiClient.callApi(
        '/buildingApi/v1/buildingGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the buildingApiV1BuildingUpdate operation.
     * @callback module:api/DefaultApi~buildingApiV1BuildingUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BuildingResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BuildingRequest} opts.body 
     * @param {module:api/DefaultApi~buildingApiV1BuildingUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BuildingResponse}
     */
    this.buildingApiV1BuildingUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BuildingResponse;

      return this.apiClient.callApi(
        '/buildingApi/v1/buildingUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinessAccountGet operation.
     * @callback module:api/DefaultApi~businessApiV1BusinessAccountGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinessAccountGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinessAccountGet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businessAccountGet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinessUpdate operation.
     * @callback module:api/DefaultApi~businessApiV1BusinessUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinessUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinessUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businessUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1BusinesslistAll operation.
     * @callback module:api/DefaultApi~businessApiV1BusinesslistAllCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1BusinesslistAllCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1BusinesslistAll = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/businesslistAll', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1CreateBusiness operation.
     * @callback module:api/DefaultApi~businessApiV1CreateBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1CreateBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1CreateBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/createBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1EraseBusiness operation.
     * @callback module:api/DefaultApi~businessApiV1EraseBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1EraseBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1EraseBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/eraseBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1OpeningHoursGet operation.
     * @callback module:api/DefaultApi~businessApiV1OpeningHoursGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1OpeningHoursGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1OpeningHoursGet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/OpeningHoursGet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the businessApiV1OpeningHoursSet operation.
     * @callback module:api/DefaultApi~businessApiV1OpeningHoursSetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BusinessResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/BusinessRequest} opts.body 
     * @param {module:api/DefaultApi~businessApiV1OpeningHoursSetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BusinessResponse}
     */
    this.businessApiV1OpeningHoursSet = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BusinessResponse;

      return this.apiClient.callApi(
        '/businessApi/v1/OpeningHoursSet', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the calendarApiV1CalendarCreate operation.
     * @callback module:api/DefaultApi~calendarApiV1CalendarCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CalendarResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CalendarRequest} opts.body 
     * @param {module:api/DefaultApi~calendarApiV1CalendarCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CalendarResponse}
     */
    this.calendarApiV1CalendarCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CalendarResponse;

      return this.apiClient.callApi(
        '/calendarApi/v1/calendarCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the calendarApiV1CalendarDelete operation.
     * @callback module:api/DefaultApi~calendarApiV1CalendarDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CalendarResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CalendarRequest} opts.body 
     * @param {module:api/DefaultApi~calendarApiV1CalendarDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CalendarResponse}
     */
    this.calendarApiV1CalendarDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CalendarResponse;

      return this.apiClient.callApi(
        '/calendarApi/v1/calendarDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the calendarApiV1CalendarGenerateBankHoliday operation.
     * @callback module:api/DefaultApi~calendarApiV1CalendarGenerateBankHolidayCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CalendarResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CalendarRequest} opts.body 
     * @param {module:api/DefaultApi~calendarApiV1CalendarGenerateBankHolidayCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CalendarResponse}
     */
    this.calendarApiV1CalendarGenerateBankHoliday = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CalendarResponse;

      return this.apiClient.callApi(
        '/calendarApi/v1/calendarGenerateBankHoliday', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the calendarApiV1CalendarGenerateSetDates operation.
     * @callback module:api/DefaultApi~calendarApiV1CalendarGenerateSetDatesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CalendarResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CalendarRequest} opts.body 
     * @param {module:api/DefaultApi~calendarApiV1CalendarGenerateSetDatesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CalendarResponse}
     */
    this.calendarApiV1CalendarGenerateSetDates = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CalendarResponse;

      return this.apiClient.callApi(
        '/calendarApi/v1/calendarGenerateSetDates', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the calendarApiV1CalendarGenerateSetDaysAndTimes operation.
     * @callback module:api/DefaultApi~calendarApiV1CalendarGenerateSetDaysAndTimesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CalendarResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CalendarRequest} opts.body 
     * @param {module:api/DefaultApi~calendarApiV1CalendarGenerateSetDaysAndTimesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CalendarResponse}
     */
    this.calendarApiV1CalendarGenerateSetDaysAndTimes = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CalendarResponse;

      return this.apiClient.callApi(
        '/calendarApi/v1/calendarGenerateSetDaysAndTimes', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the calendarApiV1CalendarGetById operation.
     * @callback module:api/DefaultApi~calendarApiV1CalendarGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CalendarResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CalendarRequest} opts.body 
     * @param {module:api/DefaultApi~calendarApiV1CalendarGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CalendarResponse}
     */
    this.calendarApiV1CalendarGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CalendarResponse;

      return this.apiClient.callApi(
        '/calendarApi/v1/calendarGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the calendarApiV1CalendarGetByType operation.
     * @callback module:api/DefaultApi~calendarApiV1CalendarGetByTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CalendarResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CalendarRequest} opts.body 
     * @param {module:api/DefaultApi~calendarApiV1CalendarGetByTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CalendarResponse}
     */
    this.calendarApiV1CalendarGetByType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CalendarResponse;

      return this.apiClient.callApi(
        '/calendarApi/v1/calendarGetByType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the calendarApiV1CalendarGetByUserIdAndType operation.
     * @callback module:api/DefaultApi~calendarApiV1CalendarGetByUserIdAndTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CalendarResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CalendarRequest} opts.body 
     * @param {module:api/DefaultApi~calendarApiV1CalendarGetByUserIdAndTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CalendarResponse}
     */
    this.calendarApiV1CalendarGetByUserIdAndType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CalendarResponse;

      return this.apiClient.callApi(
        '/calendarApi/v1/calendarGetByUserIdAndType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the calendarApiV1CalendarGetTypeList operation.
     * @callback module:api/DefaultApi~calendarApiV1CalendarGetTypeListCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CalendarResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CalendarRequest} opts.body 
     * @param {module:api/DefaultApi~calendarApiV1CalendarGetTypeListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CalendarResponse}
     */
    this.calendarApiV1CalendarGetTypeList = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CalendarResponse;

      return this.apiClient.callApi(
        '/calendarApi/v1/calendarGetTypeList', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the calendarApiV1CalendarListForUser operation.
     * @callback module:api/DefaultApi~calendarApiV1CalendarListForUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CalendarResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CalendarRequest} opts.body 
     * @param {module:api/DefaultApi~calendarApiV1CalendarListForUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CalendarResponse}
     */
    this.calendarApiV1CalendarListForUser = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CalendarResponse;

      return this.apiClient.callApi(
        '/calendarApi/v1/calendarListForUser', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the calendarApiV1CalendarUpdate operation.
     * @callback module:api/DefaultApi~calendarApiV1CalendarUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CalendarResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CalendarRequest} opts.body 
     * @param {module:api/DefaultApi~calendarApiV1CalendarUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CalendarResponse}
     */
    this.calendarApiV1CalendarUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = CalendarResponse;

      return this.apiClient.callApi(
        '/calendarApi/v1/calendarUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1ConfigUpdateBoolean operation.
     * @callback module:api/DefaultApi~configurationApiV1ConfigUpdateBooleanCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1ConfigUpdateBooleanCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1ConfigUpdateBoolean = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/configUpdateBoolean', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1ConfigUpdateInt operation.
     * @callback module:api/DefaultApi~configurationApiV1ConfigUpdateIntCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1ConfigUpdateIntCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1ConfigUpdateInt = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/configUpdateInt', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1ConfigUpdateString operation.
     * @callback module:api/DefaultApi~configurationApiV1ConfigUpdateStringCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1ConfigUpdateStringCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1ConfigUpdateString = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/configUpdateString', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1DumpConfig operation.
     * @callback module:api/DefaultApi~configurationApiV1DumpConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1DumpConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1DumpConfig = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/dumpConfig', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1ReloadConfig operation.
     * @callback module:api/DefaultApi~configurationApiV1ReloadConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1ReloadConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1ReloadConfig = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/reloadConfig', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the configurationApiV1StoreConfig operation.
     * @callback module:api/DefaultApi~configurationApiV1StoreConfigCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConfigurationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ConfigurationRequest} opts.body 
     * @param {module:api/DefaultApi~configurationApiV1StoreConfigCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ConfigurationResponse}
     */
    this.configurationApiV1StoreConfig = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConfigurationResponse;

      return this.apiClient.callApi(
        '/configurationApi/v1/storeConfig', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the loginApiV1Login operation.
     * @callback module:api/DefaultApi~loginApiV1LoginCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LoginResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LoginRequest} opts.body 
     * @param {module:api/DefaultApi~loginApiV1LoginCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LoginResponse}
     */
    this.loginApiV1Login = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LoginResponse;

      return this.apiClient.callApi(
        '/loginApi/v1/login', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the loginApiV1LoginListBusinesses operation.
     * @callback module:api/DefaultApi~loginApiV1LoginListBusinessesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LoginResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LoginRequest} opts.body 
     * @param {module:api/DefaultApi~loginApiV1LoginListBusinessesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LoginResponse}
     */
    this.loginApiV1LoginListBusinesses = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LoginResponse;

      return this.apiClient.callApi(
        '/loginApi/v1/loginListBusinesses', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the loginApiV1LoginSocial operation.
     * @callback module:api/DefaultApi~loginApiV1LoginSocialCallback
     * @param {String} error Error message, if any.
     * @param {module:model/LoginResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/LoginRequest} opts.body 
     * @param {module:api/DefaultApi~loginApiV1LoginSocialCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/LoginResponse}
     */
    this.loginApiV1LoginSocial = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = LoginResponse;

      return this.apiClient.callApi(
        '/loginApi/v1/loginSocial', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the migrateApiV1MigrateFieldDateDeleted operation.
     * @callback module:api/DefaultApi~migrateApiV1MigrateFieldDateDeletedCallback
     * @param {String} error Error message, if any.
     * @param {module:model/MigrateResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/MigrateRequest} opts.body 
     * @param {module:api/DefaultApi~migrateApiV1MigrateFieldDateDeletedCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/MigrateResponse}
     */
    this.migrateApiV1MigrateFieldDateDeleted = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = MigrateResponse;

      return this.apiClient.callApi(
        '/migrateApi/v1/migrateFieldDateDeleted', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the notificationApiV1PushNotificationCreate operation.
     * @callback module:api/DefaultApi~notificationApiV1PushNotificationCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NotificationResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NotificationRequest} opts.body 
     * @param {module:api/DefaultApi~notificationApiV1PushNotificationCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NotificationResponse}
     */
    this.notificationApiV1PushNotificationCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = NotificationResponse;

      return this.apiClient.callApi(
        '/notificationApi/v1/pushNotificationCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the paymentApiV1PaymentConfirm operation.
     * @callback module:api/DefaultApi~paymentApiV1PaymentConfirmCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaymentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PaymentRequest} opts.body 
     * @param {module:api/DefaultApi~paymentApiV1PaymentConfirmCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaymentResponse}
     */
    this.paymentApiV1PaymentConfirm = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PaymentResponse;

      return this.apiClient.callApi(
        '/paymentApi/v1/paymentConfirm', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the paymentApiV1PaymentConfirmUpdateBooks operation.
     * @callback module:api/DefaultApi~paymentApiV1PaymentConfirmUpdateBooksCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaymentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PaymentRequest} opts.body 
     * @param {module:api/DefaultApi~paymentApiV1PaymentConfirmUpdateBooksCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaymentResponse}
     */
    this.paymentApiV1PaymentConfirmUpdateBooks = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PaymentResponse;

      return this.apiClient.callApi(
        '/paymentApi/v1/paymentConfirmUpdateBooks', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the paymentApiV1PaymentCreate operation.
     * @callback module:api/DefaultApi~paymentApiV1PaymentCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaymentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PaymentRequest} opts.body 
     * @param {module:api/DefaultApi~paymentApiV1PaymentCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaymentResponse}
     */
    this.paymentApiV1PaymentCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PaymentResponse;

      return this.apiClient.callApi(
        '/paymentApi/v1/paymentCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the paymentApiV1PaymentGetByCodeTag operation.
     * @callback module:api/DefaultApi~paymentApiV1PaymentGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaymentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PaymentRequest} opts.body 
     * @param {module:api/DefaultApi~paymentApiV1PaymentGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaymentResponse}
     */
    this.paymentApiV1PaymentGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PaymentResponse;

      return this.apiClient.callApi(
        '/paymentApi/v1/paymentGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the paymentApiV1PaymentGetById operation.
     * @callback module:api/DefaultApi~paymentApiV1PaymentGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaymentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PaymentRequest} opts.body 
     * @param {module:api/DefaultApi~paymentApiV1PaymentGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaymentResponse}
     */
    this.paymentApiV1PaymentGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PaymentResponse;

      return this.apiClient.callApi(
        '/paymentApi/v1/paymentGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the paymentApiV1PaymentUpdate operation.
     * @callback module:api/DefaultApi~paymentApiV1PaymentUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaymentResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PaymentRequest} opts.body 
     * @param {module:api/DefaultApi~paymentApiV1PaymentUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaymentResponse}
     */
    this.paymentApiV1PaymentUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = PaymentResponse;

      return this.apiClient.callApi(
        '/paymentApi/v1/paymentUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the roomApiV1RoomCreate operation.
     * @callback module:api/DefaultApi~roomApiV1RoomCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RoomResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RoomRequest} opts.body 
     * @param {module:api/DefaultApi~roomApiV1RoomCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RoomResponse}
     */
    this.roomApiV1RoomCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RoomResponse;

      return this.apiClient.callApi(
        '/roomApi/v1/roomCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the roomApiV1RoomDelete operation.
     * @callback module:api/DefaultApi~roomApiV1RoomDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RoomResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RoomRequest} opts.body 
     * @param {module:api/DefaultApi~roomApiV1RoomDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RoomResponse}
     */
    this.roomApiV1RoomDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RoomResponse;

      return this.apiClient.callApi(
        '/roomApi/v1/roomDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the roomApiV1RoomGetByBuildingId operation.
     * @callback module:api/DefaultApi~roomApiV1RoomGetByBuildingIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RoomResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RoomRequest} opts.body 
     * @param {module:api/DefaultApi~roomApiV1RoomGetByBuildingIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RoomResponse}
     */
    this.roomApiV1RoomGetByBuildingId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RoomResponse;

      return this.apiClient.callApi(
        '/roomApi/v1/roomGetByBuildingId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the roomApiV1RoomGetByCodeTag operation.
     * @callback module:api/DefaultApi~roomApiV1RoomGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RoomResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RoomRequest} opts.body 
     * @param {module:api/DefaultApi~roomApiV1RoomGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RoomResponse}
     */
    this.roomApiV1RoomGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RoomResponse;

      return this.apiClient.callApi(
        '/roomApi/v1/roomGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the roomApiV1RoomGetById operation.
     * @callback module:api/DefaultApi~roomApiV1RoomGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RoomResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RoomRequest} opts.body 
     * @param {module:api/DefaultApi~roomApiV1RoomGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RoomResponse}
     */
    this.roomApiV1RoomGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RoomResponse;

      return this.apiClient.callApi(
        '/roomApi/v1/roomGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the roomApiV1RoomUpdate operation.
     * @callback module:api/DefaultApi~roomApiV1RoomUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RoomResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RoomRequest} opts.body 
     * @param {module:api/DefaultApi~roomApiV1RoomUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RoomResponse}
     */
    this.roomApiV1RoomUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RoomResponse;

      return this.apiClient.callApi(
        '/roomApi/v1/roomUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the ruleApiV1RuleCreate operation.
     * @callback module:api/DefaultApi~ruleApiV1RuleCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RuleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RuleRequest} opts.body 
     * @param {module:api/DefaultApi~ruleApiV1RuleCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RuleResponse}
     */
    this.ruleApiV1RuleCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RuleResponse;

      return this.apiClient.callApi(
        '/ruleApi/v1/ruleCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the ruleApiV1RuleDelete operation.
     * @callback module:api/DefaultApi~ruleApiV1RuleDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RuleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RuleRequest} opts.body 
     * @param {module:api/DefaultApi~ruleApiV1RuleDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RuleResponse}
     */
    this.ruleApiV1RuleDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RuleResponse;

      return this.apiClient.callApi(
        '/ruleApi/v1/ruleDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the ruleApiV1RuleGetById operation.
     * @callback module:api/DefaultApi~ruleApiV1RuleGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RuleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RuleRequest} opts.body 
     * @param {module:api/DefaultApi~ruleApiV1RuleGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RuleResponse}
     */
    this.ruleApiV1RuleGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RuleResponse;

      return this.apiClient.callApi(
        '/ruleApi/v1/ruleGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the ruleApiV1RuleListForBusiness operation.
     * @callback module:api/DefaultApi~ruleApiV1RuleListForBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RuleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RuleRequest} opts.body 
     * @param {module:api/DefaultApi~ruleApiV1RuleListForBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RuleResponse}
     */
    this.ruleApiV1RuleListForBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RuleResponse;

      return this.apiClient.callApi(
        '/ruleApi/v1/ruleListForBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the ruleApiV1RuleListForUser operation.
     * @callback module:api/DefaultApi~ruleApiV1RuleListForUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RuleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RuleRequest} opts.body 
     * @param {module:api/DefaultApi~ruleApiV1RuleListForUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RuleResponse}
     */
    this.ruleApiV1RuleListForUser = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RuleResponse;

      return this.apiClient.callApi(
        '/ruleApi/v1/ruleListForUser', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the ruleApiV1RuleUpdate operation.
     * @callback module:api/DefaultApi~ruleApiV1RuleUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/RuleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/RuleRequest} opts.body 
     * @param {module:api/DefaultApi~ruleApiV1RuleUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/RuleResponse}
     */
    this.ruleApiV1RuleUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = RuleResponse;

      return this.apiClient.callApi(
        '/ruleApi/v1/ruleUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the scheduleApiV1ScheduleCreate operation.
     * @callback module:api/DefaultApi~scheduleApiV1ScheduleCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ScheduleRequest} opts.body 
     * @param {module:api/DefaultApi~scheduleApiV1ScheduleCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduleResponse}
     */
    this.scheduleApiV1ScheduleCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ScheduleResponse;

      return this.apiClient.callApi(
        '/scheduleApi/v1/scheduleCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the scheduleApiV1ScheduleDelete operation.
     * @callback module:api/DefaultApi~scheduleApiV1ScheduleDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ScheduleRequest} opts.body 
     * @param {module:api/DefaultApi~scheduleApiV1ScheduleDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduleResponse}
     */
    this.scheduleApiV1ScheduleDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ScheduleResponse;

      return this.apiClient.callApi(
        '/scheduleApi/v1/scheduleDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the scheduleApiV1ScheduleForBusiness operation.
     * @callback module:api/DefaultApi~scheduleApiV1ScheduleForBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ScheduleRequest} opts.body 
     * @param {module:api/DefaultApi~scheduleApiV1ScheduleForBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduleResponse}
     */
    this.scheduleApiV1ScheduleForBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ScheduleResponse;

      return this.apiClient.callApi(
        '/scheduleApi/v1/scheduleForBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the scheduleApiV1ScheduleForUser operation.
     * @callback module:api/DefaultApi~scheduleApiV1ScheduleForUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ScheduleRequest} opts.body 
     * @param {module:api/DefaultApi~scheduleApiV1ScheduleForUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduleResponse}
     */
    this.scheduleApiV1ScheduleForUser = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ScheduleResponse;

      return this.apiClient.callApi(
        '/scheduleApi/v1/scheduleForUser', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the scheduleApiV1ScheduleGetListOfDates operation.
     * @callback module:api/DefaultApi~scheduleApiV1ScheduleGetListOfDatesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ScheduleRequest} opts.body 
     * @param {module:api/DefaultApi~scheduleApiV1ScheduleGetListOfDatesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduleResponse}
     */
    this.scheduleApiV1ScheduleGetListOfDates = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ScheduleResponse;

      return this.apiClient.callApi(
        '/scheduleApi/v1/scheduleGetListOfDates', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the scheduleApiV1ScheduleRecreate operation.
     * @callback module:api/DefaultApi~scheduleApiV1ScheduleRecreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ScheduleRequest} opts.body 
     * @param {module:api/DefaultApi~scheduleApiV1ScheduleRecreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduleResponse}
     */
    this.scheduleApiV1ScheduleRecreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ScheduleResponse;

      return this.apiClient.callApi(
        '/scheduleApi/v1/scheduleRecreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the scheduleApiV1ScheduleUpdate operation.
     * @callback module:api/DefaultApi~scheduleApiV1ScheduleUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ScheduleResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ScheduleRequest} opts.body 
     * @param {module:api/DefaultApi~scheduleApiV1ScheduleUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ScheduleResponse}
     */
    this.scheduleApiV1ScheduleUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ScheduleResponse;

      return this.apiClient.callApi(
        '/scheduleApi/v1/scheduleUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the serviceApiV1ServiceCreate operation.
     * @callback module:api/DefaultApi~serviceApiV1ServiceCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ServiceResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ServiceRequest} opts.body 
     * @param {module:api/DefaultApi~serviceApiV1ServiceCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ServiceResponse}
     */
    this.serviceApiV1ServiceCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ServiceResponse;

      return this.apiClient.callApi(
        '/serviceApi/v1/serviceCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the serviceApiV1ServiceDelete operation.
     * @callback module:api/DefaultApi~serviceApiV1ServiceDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ServiceResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ServiceRequest} opts.body 
     * @param {module:api/DefaultApi~serviceApiV1ServiceDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ServiceResponse}
     */
    this.serviceApiV1ServiceDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ServiceResponse;

      return this.apiClient.callApi(
        '/serviceApi/v1/serviceDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the serviceApiV1ServiceGetByCodeTag operation.
     * @callback module:api/DefaultApi~serviceApiV1ServiceGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ServiceResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ServiceRequest} opts.body 
     * @param {module:api/DefaultApi~serviceApiV1ServiceGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ServiceResponse}
     */
    this.serviceApiV1ServiceGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ServiceResponse;

      return this.apiClient.callApi(
        '/serviceApi/v1/serviceGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the serviceApiV1ServiceGetById operation.
     * @callback module:api/DefaultApi~serviceApiV1ServiceGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ServiceResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ServiceRequest} opts.body 
     * @param {module:api/DefaultApi~serviceApiV1ServiceGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ServiceResponse}
     */
    this.serviceApiV1ServiceGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ServiceResponse;

      return this.apiClient.callApi(
        '/serviceApi/v1/serviceGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the serviceApiV1ServiceGetByLevel operation.
     * @callback module:api/DefaultApi~serviceApiV1ServiceGetByLevelCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ServiceResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ServiceRequest} opts.body 
     * @param {module:api/DefaultApi~serviceApiV1ServiceGetByLevelCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ServiceResponse}
     */
    this.serviceApiV1ServiceGetByLevel = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ServiceResponse;

      return this.apiClient.callApi(
        '/serviceApi/v1/serviceGetByLevel', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the serviceApiV1ServiceUpdate operation.
     * @callback module:api/DefaultApi~serviceApiV1ServiceUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ServiceResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/ServiceRequest} opts.body 
     * @param {module:api/DefaultApi~serviceApiV1ServiceUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ServiceResponse}
     */
    this.serviceApiV1ServiceUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ServiceResponse;

      return this.apiClient.callApi(
        '/serviceApi/v1/serviceUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetCreate operation.
     * @callback module:api/DefaultApi~setApiV1SetCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetCreateWithoutUniqueId operation.
     * @callback module:api/DefaultApi~setApiV1SetCreateWithoutUniqueIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetCreateWithoutUniqueIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetCreateWithoutUniqueId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setCreateWithoutUniqueId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetDelete operation.
     * @callback module:api/DefaultApi~setApiV1SetDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetGetByCodeTag operation.
     * @callback module:api/DefaultApi~setApiV1SetGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetGetByCodeTagAndDates operation.
     * @callback module:api/DefaultApi~setApiV1SetGetByCodeTagAndDatesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetGetByCodeTagAndDatesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetGetByCodeTagAndDates = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setGetByCodeTagAndDates', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetGetById operation.
     * @callback module:api/DefaultApi~setApiV1SetGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetGetByLevel operation.
     * @callback module:api/DefaultApi~setApiV1SetGetByLevelCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetGetByLevelCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetGetByLevel = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setGetByLevel', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetGetByServiceId operation.
     * @callback module:api/DefaultApi~setApiV1SetGetByServiceIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetGetByServiceIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetGetByServiceId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setGetByServiceId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetGetByUserId operation.
     * @callback module:api/DefaultApi~setApiV1SetGetByUserIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetGetByUserIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetGetByUserId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setGetByUserId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetGetUsersInMultiple operation.
     * @callback module:api/DefaultApi~setApiV1SetGetUsersInMultipleCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetGetUsersInMultipleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetGetUsersInMultiple = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setGetUsersInMultiple', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetRemoveUser operation.
     * @callback module:api/DefaultApi~setApiV1SetRemoveUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetRemoveUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetRemoveUser = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setRemoveUser', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetUpdate operation.
     * @callback module:api/DefaultApi~setApiV1SetUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetsEmailUnpaidClient operation.
     * @callback module:api/DefaultApi~setApiV1SetsEmailUnpaidClientCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetsEmailUnpaidClientCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetsEmailUnpaidClient = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setsEmailUnpaidClient', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetsGetByBookedUserId operation.
     * @callback module:api/DefaultApi~setApiV1SetsGetByBookedUserIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetsGetByBookedUserIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetsGetByBookedUserId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setsGetByBookedUserId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetsGetByUserIdAndSwapPaymentRequired operation.
     * @callback module:api/DefaultApi~setApiV1SetsGetByUserIdAndSwapPaymentRequiredCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetsGetByUserIdAndSwapPaymentRequiredCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetsGetByUserIdAndSwapPaymentRequired = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setsGetByUserIdAndSwapPaymentRequired', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the setApiV1SetsGetPrice operation.
     * @callback module:api/DefaultApi~setApiV1SetsGetPriceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SetResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SetRequest} opts.body 
     * @param {module:api/DefaultApi~setApiV1SetsGetPriceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SetResponse}
     */
    this.setApiV1SetsGetPrice = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SetResponse;

      return this.apiClient.callApi(
        '/setApi/v1/setsGetPrice', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the swapApiV1SwapCreate operation.
     * @callback module:api/DefaultApi~swapApiV1SwapCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SwapResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SwapRequest} opts.body 
     * @param {module:api/DefaultApi~swapApiV1SwapCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SwapResponse}
     */
    this.swapApiV1SwapCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SwapResponse;

      return this.apiClient.callApi(
        '/swapApi/v1/swapCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the swapApiV1SwapDelete operation.
     * @callback module:api/DefaultApi~swapApiV1SwapDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SwapResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SwapRequest} opts.body 
     * @param {module:api/DefaultApi~swapApiV1SwapDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SwapResponse}
     */
    this.swapApiV1SwapDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SwapResponse;

      return this.apiClient.callApi(
        '/swapApi/v1/swapDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the swapApiV1SwapGetByCodeTag operation.
     * @callback module:api/DefaultApi~swapApiV1SwapGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SwapResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SwapRequest} opts.body 
     * @param {module:api/DefaultApi~swapApiV1SwapGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SwapResponse}
     */
    this.swapApiV1SwapGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SwapResponse;

      return this.apiClient.callApi(
        '/swapApi/v1/swapGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the swapApiV1SwapGetById operation.
     * @callback module:api/DefaultApi~swapApiV1SwapGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SwapResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SwapRequest} opts.body 
     * @param {module:api/DefaultApi~swapApiV1SwapGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SwapResponse}
     */
    this.swapApiV1SwapGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SwapResponse;

      return this.apiClient.callApi(
        '/swapApi/v1/swapGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the swapApiV1SwapGetByLevelAndAvailableForSwap operation.
     * @callback module:api/DefaultApi~swapApiV1SwapGetByLevelAndAvailableForSwapCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SwapResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SwapRequest} opts.body 
     * @param {module:api/DefaultApi~swapApiV1SwapGetByLevelAndAvailableForSwapCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SwapResponse}
     */
    this.swapApiV1SwapGetByLevelAndAvailableForSwap = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SwapResponse;

      return this.apiClient.callApi(
        '/swapApi/v1/swapGetByLevelAndAvailableForSwap', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the swapApiV1SwapGetByOrigBookId operation.
     * @callback module:api/DefaultApi~swapApiV1SwapGetByOrigBookIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SwapResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SwapRequest} opts.body 
     * @param {module:api/DefaultApi~swapApiV1SwapGetByOrigBookIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SwapResponse}
     */
    this.swapApiV1SwapGetByOrigBookId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SwapResponse;

      return this.apiClient.callApi(
        '/swapApi/v1/swapGetByOrigBookId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the swapApiV1SwapGetByServiceId operation.
     * @callback module:api/DefaultApi~swapApiV1SwapGetByServiceIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SwapResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SwapRequest} opts.body 
     * @param {module:api/DefaultApi~swapApiV1SwapGetByServiceIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SwapResponse}
     */
    this.swapApiV1SwapGetByServiceId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SwapResponse;

      return this.apiClient.callApi(
        '/swapApi/v1/swapGetByServiceId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the swapApiV1SwapGetBySetId operation.
     * @callback module:api/DefaultApi~swapApiV1SwapGetBySetIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SwapResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SwapRequest} opts.body 
     * @param {module:api/DefaultApi~swapApiV1SwapGetBySetIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SwapResponse}
     */
    this.swapApiV1SwapGetBySetId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SwapResponse;

      return this.apiClient.callApi(
        '/swapApi/v1/swapGetBySetId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the swapApiV1SwapGetByUserId operation.
     * @callback module:api/DefaultApi~swapApiV1SwapGetByUserIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SwapResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SwapRequest} opts.body 
     * @param {module:api/DefaultApi~swapApiV1SwapGetByUserIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SwapResponse}
     */
    this.swapApiV1SwapGetByUserId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SwapResponse;

      return this.apiClient.callApi(
        '/swapApi/v1/swapGetByUserId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the swapApiV1SwapUpdate operation.
     * @callback module:api/DefaultApi~swapApiV1SwapUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SwapResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/SwapRequest} opts.body 
     * @param {module:api/DefaultApi~swapApiV1SwapUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SwapResponse}
     */
    this.swapApiV1SwapUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = SwapResponse;

      return this.apiClient.callApi(
        '/swapApi/v1/swapUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserAuthenticate operation.
     * @callback module:api/DefaultApi~userApiV1UserAuthenticateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserAuthenticateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserAuthenticate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userAuthenticate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserCreate operation.
     * @callback module:api/DefaultApi~userApiV1UserCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserCreateGlobal operation.
     * @callback module:api/DefaultApi~userApiV1UserCreateGlobalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserCreateGlobalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserCreateGlobal = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userCreateGlobal', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserDelete operation.
     * @callback module:api/DefaultApi~userApiV1UserDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserGetAccount operation.
     * @callback module:api/DefaultApi~userApiV1UserGetAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserGetAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserGetAccount = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userGetAccount', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserListByLevel operation.
     * @callback module:api/DefaultApi~userApiV1UserListByLevelCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserListByLevelCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserListByLevel = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userListByLevel', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserListByRoleType operation.
     * @callback module:api/DefaultApi~userApiV1UserListByRoleTypeCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserListByRoleTypeCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserListByRoleType = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userListByRoleType', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserListInBusiness operation.
     * @callback module:api/DefaultApi~userApiV1UserListInBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserListInBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserListInBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userListInBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userApiV1UserUpdateAccount operation.
     * @callback module:api/DefaultApi~userApiV1UserUpdateAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/UserRequest} opts.body 
     * @param {module:api/DefaultApi~userApiV1UserUpdateAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserResponse}
     */
    this.userApiV1UserUpdateAccount = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = UserResponse;

      return this.apiClient.callApi(
        '/userApi/v1/userUpdateAccount', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the voucherApiV1VoucherCreate operation.
     * @callback module:api/DefaultApi~voucherApiV1VoucherCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoucherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/VoucherRequest} opts.body 
     * @param {module:api/DefaultApi~voucherApiV1VoucherCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoucherResponse}
     */
    this.voucherApiV1VoucherCreate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = VoucherResponse;

      return this.apiClient.callApi(
        '/voucherApi/v1/voucherCreate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the voucherApiV1VoucherCreateAndSendToClient operation.
     * @callback module:api/DefaultApi~voucherApiV1VoucherCreateAndSendToClientCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoucherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/VoucherRequest} opts.body 
     * @param {module:api/DefaultApi~voucherApiV1VoucherCreateAndSendToClientCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoucherResponse}
     */
    this.voucherApiV1VoucherCreateAndSendToClient = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = VoucherResponse;

      return this.apiClient.callApi(
        '/voucherApi/v1/voucherCreateAndSendToClient', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the voucherApiV1VoucherDelete operation.
     * @callback module:api/DefaultApi~voucherApiV1VoucherDeleteCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoucherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/VoucherRequest} opts.body 
     * @param {module:api/DefaultApi~voucherApiV1VoucherDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoucherResponse}
     */
    this.voucherApiV1VoucherDelete = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = VoucherResponse;

      return this.apiClient.callApi(
        '/voucherApi/v1/voucherDelete', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the voucherApiV1VoucherGetByCodeTag operation.
     * @callback module:api/DefaultApi~voucherApiV1VoucherGetByCodeTagCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoucherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/VoucherRequest} opts.body 
     * @param {module:api/DefaultApi~voucherApiV1VoucherGetByCodeTagCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoucherResponse}
     */
    this.voucherApiV1VoucherGetByCodeTag = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = VoucherResponse;

      return this.apiClient.callApi(
        '/voucherApi/v1/voucherGetByCodeTag', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the voucherApiV1VoucherGetById operation.
     * @callback module:api/DefaultApi~voucherApiV1VoucherGetByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoucherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/VoucherRequest} opts.body 
     * @param {module:api/DefaultApi~voucherApiV1VoucherGetByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoucherResponse}
     */
    this.voucherApiV1VoucherGetById = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = VoucherResponse;

      return this.apiClient.callApi(
        '/voucherApi/v1/voucherGetById', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the voucherApiV1VoucherGetByUserId operation.
     * @callback module:api/DefaultApi~voucherApiV1VoucherGetByUserIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoucherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/VoucherRequest} opts.body 
     * @param {module:api/DefaultApi~voucherApiV1VoucherGetByUserIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoucherResponse}
     */
    this.voucherApiV1VoucherGetByUserId = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = VoucherResponse;

      return this.apiClient.callApi(
        '/voucherApi/v1/voucherGetByUserId', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the voucherApiV1VoucherGetByVoucherName operation.
     * @callback module:api/DefaultApi~voucherApiV1VoucherGetByVoucherNameCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoucherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/VoucherRequest} opts.body 
     * @param {module:api/DefaultApi~voucherApiV1VoucherGetByVoucherNameCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoucherResponse}
     */
    this.voucherApiV1VoucherGetByVoucherName = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = VoucherResponse;

      return this.apiClient.callApi(
        '/voucherApi/v1/voucherGetByVoucherName', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the voucherApiV1VoucherListValidVouchersForBusiness operation.
     * @callback module:api/DefaultApi~voucherApiV1VoucherListValidVouchersForBusinessCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoucherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/VoucherRequest} opts.body 
     * @param {module:api/DefaultApi~voucherApiV1VoucherListValidVouchersForBusinessCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoucherResponse}
     */
    this.voucherApiV1VoucherListValidVouchersForBusiness = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = VoucherResponse;

      return this.apiClient.callApi(
        '/voucherApi/v1/voucherListValidVouchersForBusiness', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the voucherApiV1VoucherUpdate operation.
     * @callback module:api/DefaultApi~voucherApiV1VoucherUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoucherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/VoucherRequest} opts.body 
     * @param {module:api/DefaultApi~voucherApiV1VoucherUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoucherResponse}
     */
    this.voucherApiV1VoucherUpdate = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = VoucherResponse;

      return this.apiClient.callApi(
        '/voucherApi/v1/voucherUpdate', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the voucherApiV1VoucherUpdateUsage operation.
     * @callback module:api/DefaultApi~voucherApiV1VoucherUpdateUsageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VoucherResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/VoucherRequest} opts.body 
     * @param {module:api/DefaultApi~voucherApiV1VoucherUpdateUsageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VoucherResponse}
     */
    this.voucherApiV1VoucherUpdateUsage = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = VoucherResponse;

      return this.apiClient.callApi(
        '/voucherApi/v1/voucherUpdateUsage', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/api/DefaultApi.js